export default __webpack_public_path__ + "static/media/tj.a67a2a98.svg";